module.exports = __webpack_public_path__ + "static/img/rrrr_45.b3891d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/resources/images/icon/rrrr_45.png
// module id = 1Huq
// module chunks = 1